import React from "react";
import { unslufigy } from "../../helpers/StringHelper";
import { toggleFailedSiteFilter } from "./FailedSite-Action";
import store from "../../Store";
import { connect } from "react-redux";

class FailedSiteListFilters extends React.Component {
  toggleFilter = (e) => {
    store.dispatch(toggleFailedSiteFilter(e));
  };

  render() {
    let { title, params } = this.props;

    return (
      <div className="heading-block pr-60">
        <div className="title-block">
          <h2>{unslufigy(title)}</h2>
        </div>
        <div className="search-bar">
          <input
            type="text"
            className="form-control"
            name="q"
            placeholder={`Search ${unslufigy(title)}`}
            value={params.q}
            onChange={(e) => this.toggleFilter(e)}
          />
          <span className="icon-search" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { globalFailedTnxList } = state;
  const { params } = globalFailedTnxList.data;

  return { params };
}

export default connect(mapStateToProps)(FailedSiteListFilters);
